module.exports = __webpack_public_path__ + "img/frame-head.89977ab1.webp";